import { ThreadObject, BlogPost } from "types/app";
import fm from "front-matter";

export const parseMessage = (
  postThread: ThreadObject,
  moderatorNames?: { [key: string]: string }
): BlogPost => {
  try {
    const parsedMessage: any = fm(postThread.message);
    const author = moderatorNames
      ? moderatorNames[postThread.author]
      : postThread.author;

    const tags = parsedMessage.attributes.tags
      ? parsedMessage.attributes.tags.split(",")
      : [];
    return {
      title: parsedMessage.attributes.title,
      description: parsedMessage.attributes.description,
      thumbnail: parsedMessage.attributes.thumbnail,
      body: parsedMessage.body,
      threadData: { ...postThread, author },
      tags,
    };
  } catch (error) {
    console.error(error);
    return {
      title: "Error Parsing message",
      description: "",
      thumbnail: "",
      body: postThread.message,
      threadData: { ...postThread, author: "author" },
      tags: [],
    };
  }
};

export const parseDraftMessage = (
  postThread: ThreadObject,
  moderatorNames?: { [key: string]: string }
): BlogPost => {
  try {
    const parsedMessage: any = fm(postThread.message);
    const author = moderatorNames
      ? moderatorNames[postThread.author]
      : postThread.author;

    // update timestamp from postThread.message attributes
    const timestamp = parsedMessage.attributes.createdAt;
    postThread.timestamp = timestamp;

    const tags = parsedMessage.attributes.tags
      ? parsedMessage.attributes.tags.split(",")
      : [];
    return {
      title: parsedMessage.attributes.title,
      description: parsedMessage.attributes.description,
      thumbnail: parsedMessage.attributes.thumbnail,
      body: parsedMessage.body,
      threadData: { ...postThread, author },
      tags,
    };
  } catch (error) {
    console.error(error);
    return {
      title: "Error Parsing message",
      description: "",
      thumbnail: "",
      body: postThread.message,
      threadData: { ...postThread, author: "author" },
      tags: [],
    };
  }
};
